module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Couch-949aa7ef90ef16ce5b4def3f025053d4.svg";